import { Injectable } from '@angular/core';
import { AssessRequestRaService } from '../../assess-request-ra/assess-request-ra.service';

/**
 * Service for binding Information and MaxLimitInfo comment columns
 * Handles hyperlink extraction, comment transformation, and HTML preparation for dialogs
 * Usage: Call bindInformationAndCommentColumns(dataArray, assessRequestRaService) - returns processed data
 */
@Injectable({
  providedIn: 'root'
})
export class ColumnBindingService {

  constructor(
    public assessRequestRaService: AssessRequestRaService
  ) { }


    bindInformationAndCommentColumns(data: any[]) {
      for (const obj of data) {
        // Bind Max Limit Info Comment Column
        if (obj.positiveStatement) {
          obj.maxLimitInfoComment = obj.positiveStatement;
          obj.originalMaxLimitInfoComment = obj.maxLimitInfoComment;
          let allLinksCombined = '';
          const maxLimitInfoLinkRuleData = this.assessRequestRaService.hyperLinksToSheet(obj.maxLimitInfoComment);

          allLinksCombined = maxLimitInfoLinkRuleData
            .filter(item => item && item.hyperlink)
            .map(item => item.hyperlink) // extract only hyperlink
            .join(', ');

          obj.maxLimitInfoComment = this.changeComment(obj.maxLimitInfoComment);
          obj.maxLimitInfoCommentStripped = this.handleSpecialCharacters(obj.originalMaxLimitInfoComment);

          obj.maxLimitInfoCommentTextWithLink = obj.maxLimitInfoCommentStripped;
          if (allLinksCombined) {
            obj.maxLimitInfoCommentTextWithLink += ' :: All links: ' + allLinksCombined;
          }


        }

        // Bind Information Column
        if (obj.information) {
          obj.maxLimitInfoRuleInfoText = obj.information;
          obj.originalInformation = obj.maxLimitInfoRuleInfoText;
          let allLinksCombined = '';
          const informationLinkRuleData = this.assessRequestRaService.hyperLinksToSheet(obj.maxLimitInfoRuleInfoText);

          allLinksCombined = informationLinkRuleData
            .filter(item => item && item.hyperlink)
            .map(item => item.hyperlink) // extract only hyperlink
            .join(', ');

          obj.maxLimitInfoRuleInfoText = this.changeComment(obj.maxLimitInfoRuleInfoText);
          obj.informationStripped = this.handleSpecialCharacters(obj.originalInformation);

          obj.informationTextWithLink = obj.informationStripped;
          if (allLinksCombined) {
            obj.informationTextWithLink += ' :: All links: ' + allLinksCombined;
          }
        }
      }
      return data;
    }


  private changeComment(input) {
    const strValue = input;
    const ar = strValue ? strValue.match(/<a.*?<\/a>/g) : null;
    let commentwarning = '';
    if ((ar !== null) && (ar.length === 0 || ar.length > 0)) {
      commentwarning = 'Click Here';
    } else {
      commentwarning = input;
    }
    return commentwarning;
  }


  private handleSpecialCharacters(text) {
    if (text) {
      return text.replace(/<.*?>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;.*?/gi, '').replace(/&amp;/g, '&');
    }
  }

}
